var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLinkYoutube(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10 20C15.5228 20 20 15.5228 20 10C20 4.47715 15.5228 0 10 0C4.47715 0 0 4.47715 0 10C0 15.5228 4.47715 20 10 20ZM15.0775 5.77319C15.6333 5.92391 16.0761 6.36667 16.2268 6.93188C16.5 7.94928 16.5 10.0783 16.5 10.0783C16.5 10.0783 16.5 12.2073 16.2268 13.2246C16.0761 13.7899 15.6333 14.2326 15.0775 14.3833C14.0696 14.6565 10 14.6565 10 14.6565C10 14.6565 5.93986 14.6565 4.92246 14.3833C4.36667 14.2326 3.92391 13.7899 3.77319 13.2246C3.5 12.2073 3.5 10.0783 3.5 10.0783C3.5 10.0783 3.5 7.94928 3.77319 6.93188C3.92391 6.36667 4.36667 5.92391 4.92246 5.77319C5.93043 5.5 10 5.5 10 5.5C10 5.5 14.0601 5.5 15.0775 5.77319ZM12.0725 10.0783L8.67174 8.1471V12.0094L12.0725 10.0783Z",
    fill: "#666666"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkYoutube);
export default __webpack_public_path__ + "static/media/link-youtube.946af2fbf6a3af4c726f0edbf2bf3beb.svg";
export { ForwardRef as ReactComponent };